import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

// Tras publicar una versión nueva, el navegador puede pedir trozos de la anterior: se recarga solo
window.addEventListener("error", (e) => {
  const msg = `${e?.message || ""} ${e?.error?.name || ""}`;
  if (/chunkloaderror|loading chunk|loading css chunk/i.test(msg)
      && !sessionStorage.getItem("bspark_recarga")) {
    sessionStorage.setItem("bspark_recarga", "1");
    window.location.reload();
  }
});

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
